import { toStatisticNumber } from 'utils/statisticNumber';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { api, apiUtils } from 'app/services';
import {
KBLoadingContainer,
KBAvatar,
KBRangeDate,
KBPopover,
KBTipsy } from
'components';
import * as selectors from 'app/selectors';
import { KBDropSelect } from 'components/plugins';
import dayjs from 'utils/dayjs';
import { STATISTIC_CYCLE } from 'app/constants';
import { KBSelect } from 'components/views';
import { InitialHighCharts } from 'components/mixins';
import { percent, getYMD } from 'utils/kbUtil';
import {
extendDefaultHighchartsConfig,
getStatisticInitialDate,
getInitialDate } from
'utils/kbData';

var StatisticCrmCustomer = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.parseLoadFromTo = this.parseLoadFromTo.bind(this);this._loadData = this._loadData.bind(this);this.parseJSON = this.parseJSON.bind(this);this.compare = this.compare.bind(this);this.fillChart = this.fillChart.bind(this);this.selectLocationCallBack = this.selectLocationCallBack.bind(this);this.selectCityCallBack = this.selectCityCallBack.bind(this);this._setFilters = this._setFilters.bind(this);this.changeDate = this.changeDate.bind(this);this.cycleChange = this.cycleChange.bind(this);this.setMonthFilters = this.setMonthFilters.bind(this);}getInitialState()

  {
    const { from, to } = getStatisticInitialDate();
    return {
      filters: {
        from,
        to,
        cycle: 'weekly' },

      data: [],
      month: '' };

  }componentDidMount()

  {
    const { filters, data } = this.state;

    this.mounted = true;

    let Highcharts = this.getHighcharts();
    let filtersMonths = dayjs(filters.to).diff(dayjs(filters.from), 'months');
    this.setState({
      month: filtersMonths });

    this._loadData(filters);
    this.renderChart(
    'Chart',
    extendDefaultHighchartsConfig({
      chart: {
        type: 'spline' },

      title: {
        text: null },

      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          // don't display the dummy year
          month: '%e. %b',
          year: '%b' },

        title: {
          text: '时间' },

        labels: {
          format: '{value:%Y-%m-%d}' } },


      yAxis: {
        title: {
          text: '人数' } },


      tooltip: {
        headerFormat: '<b>{series.name}</b><br>',
        pointFormat: '日期：{point.x:%Y-%m-%d}, 人数：{point.y}' },

      plotOptions: {
        spline: {
          marker: {
            enabled: true } } },



      series: data }));


  }componentWillUnmount()

  {
    this.mounted = false;
  }parseLoadFromTo(


  params, from, to) {
    delete params.from;
    delete params.to;

    params.start_date = from ? getInitialDate(from).initStartDateString : null;
    params.end_date = to ? getInitialDate(to).initEndDateString : null;

    return params;
  }_loadData(

  filters) {
    const { from, to, cycle, location_ids, city_ids } = filters;
    var params = { location_ids, city_ids };

    params.cycle = cycle;
    // 判断日期
    params = this.parseLoadFromTo(params, from, to);

    api.getCustomerStatistic(params).then(({ json }) => {
      if (!json.statistic) {
        return;
      }

      this.parseJSON(json.statistic);
    });
  }parseJSON(

  json) {
    var contain = {};
    let data = [];
    const {
      filters: { cycle } } =
    this.state;

    if (!json || !Object.keys(json).length) {
      if (this.mounted) {
        this.setState({
          data });

      }
    }

    var array = Object.values(json);
    array.forEach(json => {
      let dt = {};
      dt.data = [];
      dt.name = json.location && json.location.name || '当前空间客户个数统计';
      json.location &&
      json.location.statistic.forEach(t => {
        if (!t) {
          return;
        }

        let { year, month, day } = getYMD(t.date);
        dt.data.push([Date.UTC(year, month, day), toStatisticNumber(t.customer_count)]);
      });

      dt.data.sort(this.compare);
      data.push(dt);
    });

    this.fillChart(data);
  }compare(

  a, b) {
    if (a[0] - b[0] > 0) {
      return 1;
    } else if (a[0] - b[0] < 0) {
      return -1;
    }

    return 0;
  }fillChart(

  data) {
    this.setSerierDate(data);
  }selectLocationCallBack(

  data) {
    this._setFilters({
      location_ids: data.map(json => json.id).join(',') });

  }selectCityCallBack(

  data) {
    this._setFilters({
      city_ids: data.map(json => json.id).join(',') });

  }_setFilters(

  obj) {
    let newFilters = Object.assign({}, this.state.filters, obj);
    this.setState({
      filters: newFilters });

    this._loadData(newFilters);
  }changeDate(

  range) {
    this._setFilters(range);
    this.setState({
      month: '' });

  }cycleChange(

  data) {
    this._setFilters({
      cycle: data });

  }setMonthFilters(

  num = 1) {
    var to = dayjs().toDate();
    var from = dayjs().
    subtract(num, 'months').
    toDate();

    this.setState({
      month: num });


    this._setFilters({
      from,
      to });

  }render()

  {
    const { locations, cities } = this.props;
    const { filters, data, month } = this.state;
    const { from, to, cycle } = filters;
    return (
      <article>
        <div className="chart-title m-top-lg">
          <span>CRM客户个数统计图</span>
          <button className="bordered-btn-small" onClick={this.print}>
            <i className="iconfont icon-contract" />
            打印
          </button>
          <button className="bordered-btn-small" onClick={this.exportingExcel}>
            <i className="iconfont icon-EXCEL" />
            导出Excel
          </button>
        </div>
        <div className="m-bottom-sm">
          <KBRangeDate
          format="YYYY/MM/DD"
          from={from || ''}
          to={to || ''}
          callback={this.changeDate}
          leftNone={true} />

          <div className="time-filter">
            <button
            className={month == 1 ? 'active' : ''}
            onClick={this.setMonthFilters.bind(null, 1)}>

              1个月
            </button>
            <button
            className={month == 3 ? 'active' : ''}
            onClick={this.setMonthFilters.bind(null, 3)}>

              3个月
            </button>
            <button
            className={month == 6 ? 'active' : ''}
            onClick={this.setMonthFilters.bind(null, 6)}>

              6个月
            </button>
            <button
            className={month == 12 ? 'active' : ''}
            onClick={this.setMonthFilters.bind(null, 12)}>

              1年
            </button>
          </div>
          <KBDropSelect
          options={{ defaultSelectPrompt: '选择城市' }}
          defaultData={cities}
          multi={true}
          callback={this.selectCityCallBack}
          style={{ marginLeft: 20 }} />

          <KBDropSelect
          options={{ defaultSelectPrompt: '选择分店' }}
          defaultData={locations}
          multi={true}
          callback={this.selectLocationCallBack}
          style={{ marginLeft: 20 }} />

        </div>
        <div ref={ref => { this.highcharts = ref; }} />
      </article>);

  }};Object.assign(StatisticCrmCustomer.prototype, InitialHighCharts);


function mapStateToProps(state, props) {
  const user = selectors.getCurrentUser(state);
  const cities = user.cities;
  const locations = selectors.getSerializeLocation(state);
  return {
    cities,
    locations };

}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(
mapStateToProps,
mapDispatchToProps)(
StatisticCrmCustomer);
